(() => {
  'use strict';
  if (window.aoAdversarialUxFixesBooted) return;
  window.aoAdversarialUxFixesBooted = true;

  const restoreMobilePdp = () => {
    document.querySelectorAll('[data-ao-mobile-purchase-anchor]').forEach(anchor => {
      const key = anchor.getAttribute('data-ao-mobile-purchase-anchor');
      const node = document.querySelector(`[data-ao-mobile-purchase-node="${key}"]`);
      if (node && anchor.parentNode) {
        anchor.parentNode.insertBefore(node, anchor.nextSibling);
        node.removeAttribute('data-ao-mobile-purchase-node');
      }
      anchor.remove();
    });
    document.querySelectorAll('[data-ao-mobile-purchase-priority]').forEach(node => node.remove());
    document.querySelectorAll('[data-ao-mobile-purchase-node]').forEach(node => node.removeAttribute('data-ao-mobile-purchase-node'));
  };

  const suppressDrawerUpsells = () => {
    document.querySelectorAll('header-cart-drawer *').forEach(node => {
      if (node.children.length || node.textContent.trim().toLowerCase() !== 'goes great with') return;
      let candidate = node.parentElement;
      while (candidate && !candidate.matches('.cart__drawer-form')) {
        const buttons = candidate.querySelectorAll('button, a').length;
        if (buttons >= 2) {
          candidate.hidden = true;
          candidate.setAttribute('data-ao-cart-upsell-hidden', '');
          break;
        }
        candidate = candidate.parentElement;
      }
    });
    document.querySelectorAll('header-cart-drawer .cart-recommendations').forEach(node => {
      node.hidden = true;
      node.setAttribute('data-ao-cart-upsell-hidden', '');
    });
  };

  const isSoldOutCard = card => {
    if (!card || card.nodeType !== 1) return false;
    if (card.querySelector('.ao-cro-button--unavailable, button[name="add"][disabled], [aria-disabled="true"]')) return true;
    const stock = card.querySelector('.ao-cro-card__stock, [class*="inventory"], [class*="stock"], button, .btn');
    return !!(stock && /\bsold out\b/i.test(stock.textContent || ''));
  };

  const pushSoldOutToEnd = () => {
    document.querySelectorAll('.collection-grid').forEach(grid => {
      const cards = Array.from(grid.children);
      if (cards.length < 2) return;
      const available = cards.filter(card => !isSoldOutCard(card));
      const soldOut = cards.filter(isSoldOutCard);
      if (!available.length || !soldOut.length) return;
      const desired = available.concat(soldOut);
      if (desired.every((node, index) => node === cards[index])) return;
      const fragment = document.createDocumentFragment();
      desired.forEach(node => fragment.appendChild(node));
      grid.appendChild(fragment);
    });
  };

  const suppressExpiredPromoLinks = () => {
    document.querySelectorAll('header a, header-drawer a, nav a').forEach(link => {
      const text = (link.textContent || '').trim().replace(/\s+/g, ' ').toLowerCase();
      const href = (link.getAttribute('href') || '').toLowerCase();
      if (text !== 'labor day sale' && !href.includes('laborday26')) return;
      const item = link.closest('li, .site-nav__item, .mobile-nav__item, .header-item') || link;
      if (!item.hidden) {
        item.hidden = true;
        item.setAttribute('data-ao-expired-promo-hidden', '');
      }
    });
  };

  let queued = false;
  const apply = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      queued = false;
      restoreMobilePdp();
      suppressDrawerUpsells();
      pushSoldOutToEnd();
      suppressExpiredPromoLinks();
    }));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('ajaxProduct:added', () => setTimeout(apply, 50));
  window.addEventListener('resize', apply, { passive: true });

  const startObserver = () => {
    if (!document.body) return;
    const observer = new MutationObserver(apply);
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  else startObserver();
})();
